import controller from './devtool.controller';
import template from './devtool.html';
import './devtool.scss';

export default {
	template,
	bindings: {},
	controller,
	controllerAs: '$ctrl',
};
